import { Container } from 'inversify'
import 'reflect-metadata'
import TYPES from '@/config/Types'
import { IConfig, Config } from '@/config/Config'
import { IAuth0Config, Auth0Config } from '@/config/Auth0Config'
import { ApiService, ApiServiceImpl } from '@/service/ApiService'
import { AuthService, AuthServiceImpl } from '@/service/AuthService'
import { PostService, PostServiceImpl } from '@/service/PostService'
import { CommentService, CommentServiceImpl } from '@/service/CommentService'
import { UserService, UserServiceImpl } from '@/service/UserService'
import { StatementService, StatementServiceImpl } from '@/service/StatementService'
import { ConvoService, ConvoServiceImpl } from '@/service/ConvoService'
import { AuthHandler, Auth0Handler, SessionHandler } from '@/service/AuthHandler';
import { WebAuthContainer } from '@/service/WebAuthContainer';

export class DependencyContainer {
  private static container: Container | null = null

  public static getContainer (): Container {
    if (this.container === null) {
      this.container = new Container()
      this.container.bind<AuthHandler>(TYPES.AuthHandler).to(Auth0Handler).inSingletonScope()
      this.container.bind<SessionHandler>(TYPES.SessionHandler).to(Auth0Handler).inSingletonScope()
      this.container.bind<ApiService>(TYPES.ApiService).to(ApiServiceImpl).inSingletonScope()
      this.container.bind<AuthService>(TYPES.AuthService).to(AuthServiceImpl).inSingletonScope()
      this.container.bind<CommentService>(TYPES.CommentService).to(CommentServiceImpl).inSingletonScope()
      this.container.bind<ConvoService>(TYPES.ConvoService).to(ConvoServiceImpl).inSingletonScope()
      this.container.bind<PostService>(TYPES.PostService).to(PostServiceImpl).inSingletonScope()
      this.container.bind<StatementService>(TYPES.StatementService).to(StatementServiceImpl).inSingletonScope()
      this.container.bind<UserService>(TYPES.UserService).to(UserServiceImpl).inSingletonScope()
      this.container.bind<IConfig>(TYPES.IConfig).to(Config).inSingletonScope()
      this.container.bind<IAuth0Config>(TYPES.IAuth0Config).to(Auth0Config).inSingletonScope()
      this.container.bind<WebAuthContainer>(TYPES.WebAuthContainer).to(WebAuthContainer).inSingletonScope()
    }

    return this.container
  }
}
